// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/wave-pattern.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.combineMain {
  background-color: #07405E;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  background-image: linear-gradient(180deg, rgba(0, 84, 130, 0.87), rgb(0, 47, 72)), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: repeat-x;
}
.combineMain .instructionCircle {
  color: #699BB6;
  font-weight: 600;
  line-height: 140%;
  text-align: center;
  width: 80%;
  font-size: 22px;
  font-family: "Roboto", sans-serif;
  margin-top: -30dvh;
  position: absolute;
  margin-top: 20dvh;
}
@media (max-width: 350px) {
  .combineMain .instructionCircle {
    margin-top: 12dvh;
  }
}
.combineMain .combineContainer {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100dvh;
  padding: 10px 0px;
}
@media (min-width: 450px) {
  .combineMain .combineContainer {
    width: 400px;
  }
}
@media only screen and (max-height: 712px) {
  .combineMain .combineContainer {
    height: 100%;
  }
}
.combineMain .combineContainer .circle {
  display: grid;
  grid-template-areas: "layer";
  place-items: center;
  background: radial-gradient(circle at center, rgb(131, 219, 253) 0%, rgba(65, 223, 255, 0.8) 50%, rgba(65, 223, 255, 0) 100%);
  outline: 0px;
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);
  box-shadow: rgb(132, 220, 255) 0px 0px 440px 10px;
  border-radius: 50%;
  position: relative;
  z-index: 2;
  --radius: 19vmin;
  width: calc(2 * var(--radius));
  height: calc(2 * var(--radius));
}
@media (max-width: 500px) {
  .combineMain .combineContainer .circle {
    --radius: 30vmin;
  }
}
.combineMain .combineContainer .circle::before {
  content: "";
  animation: pulseShadow 2s linear infinite;
  z-index: -1;
  position: absolute;
  inset: -1px;
  border-radius: 50%;
  background: radial-gradient(circle at center, rgb(131, 219, 253) 0%, rgba(65, 223, 255, 0.9) 50%, rgba(65, 223, 255, 0) 100%);
  filter: blur(40px);
}
.combineMain .combineContainer .stat {
  grid-area: layer;
  width: 10vmin;
  height: 10vmin;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background-position: "center";
  color: #185adb;
  font-weight: bold;
  font-size: 3vmin;
  --d: calc(var(--i) / var(--total));
  --r-offset: 1turn;
  --r-amount: 1turn;
  --r: calc((var(--r-amount) * var(--d)) + var(--r-offset));
  --transform: rotate(var(--r)) translate(var(--radius))
    rotate(calc(-1 * var(--r)));
  transform: var(--transform);
  transition: transform 1s ease-in;
  transition-delay: calc(0.1s / var(--i1));
}
.combineMain .combineContainer .stat .circle {
  --radius: calc(-20vmin);
  --r-offset: -1.75turn;
}
.combineMain .combineContainer .diamond {
  background-repeat: no-repeat;
  background-position: center;
  width: 40%;
  height: 40%;
  z-index: 2;
  position: relative;
  background-size: 100% 100%;
}
@media screen and (max-width: 450px) {
  .combineMain .combineContainer .diamond {
    width: 55%;
    height: 55%;
  }
}
.combineMain .diamondsReaction {
  animation-name: combine-diamonds;
  min-height: 20px;
  min-width: 20px;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: rgb(255, 0, 0);
  background: radial-gradient(circle at center, rgb(131, 219, 253) 0%, rgb(65, 223, 255) 50%, rgb(65, 223, 255) 100%);
  position: absolute;
  z-index: 3;
  left: 47%;
  right: 40%;
  bottom: 47%;
  animation-duration: 1.5s;
}
.combineMain .diamondsReaction::before {
  content: "";
  position: absolute;
  inset: -1px;
  background: linear-gradient(90deg, #5f8e8b 0%, rgb(97, 184, 255) 35%);
  filter: blur(8px);
}
.combineMain.clicked .stat {
  transform: rotate(0) translate(0) rotate(0);
}
@keyframes combine-diamonds {
  0% {
    -webkit-transform: scale(10);
    opacity: 1;
  }
  60% {
    -webkit-transform: scale(20);
    opacity: 0.5;
  }
  100% {
    -webkit-transform: scale(30);
    opacity: 0;
  }
}
@keyframes pulseShadow {
  0% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.3;
  }
}
@keyframes chestBlink {
  0% {
    -webkit-transform: scale(3);
    opacity: 1;
  }
  70% {
    -webkit-transform: scale(10);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(20);
    opacity: 0;
  }
}

.green-gradient {
  background: radial-gradient(circle at center, rgb(56, 183, 56) 0%, rgba(111, 201, 111, 0.8) 50%, rgba(167, 255, 167, 0) 100%) !important;
  box-shadow: rgb(111, 201, 111) 0px 0px 440px 10px !important;
}
.green-gradient::before {
  background: radial-gradient(circle at center, rgb(56, 183, 56) 0%, rgba(111, 201, 111, 0.8) 50%, rgba(167, 255, 167, 0) 100%) !important;
}

.red-gradient {
  background: radial-gradient(circle at center, rgb(183, 56, 56) 0%, rgba(162, 94, 94, 0.8) 50%, rgba(255, 167, 167, 0) 100%) !important;
  box-shadow: rgb(163, 91, 91) 0px 0px 440px 10px !important;
}
.red-gradient::before {
  background: radial-gradient(circle at center, rgb(183, 56, 56) 0%, rgba(179, 92, 92, 0.8) 50%, rgba(255, 167, 167, 0) 100%) !important;
}

.blue-gradient {
  background: radial-gradient(circle at center, rgb(56, 56, 183) 0%, rgba(111, 111, 201, 0.8) 50%, rgba(167, 167, 255, 0) 100%) !important;
  box-shadow: rgb(111, 111, 201) 0px 0px 440px 10px !important;
}
.blue-gradient::before {
  background: radial-gradient(circle at center, rgb(56, 56, 183) 0%, rgba(111, 111, 201, 0.8) 50%, rgba(167, 167, 255, 0) 100%) !important;
}`, "",{"version":3,"sources":["webpack://./src/modules/combining/index.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/fonts.scss"],"names":[],"mappings":"AAIA;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,0HAAA;EACA,2BAAA;AAFJ;AAGI;EACI,cCbS;EDcT,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,iCEfC;EFgBD,kBAAA;EACA,kBAAA;EACA,iBAAA;AADR;AAEQ;EAXJ;IAYQ,iBAAA;EACV;AACF;AAEI;EAOI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AANR;AANQ;EADJ;IAEQ,YAAA;EASV;AACF;AARQ;EAJJ;IAKQ,YAAA;EAWV;AACF;AAFQ;EACI,aAAA;EACA,4BAAA;EACA,mBAAA;EACA,6HAAA;EAMA,YAAA;EACA,mCAAA;UAAA,2BAAA;EACA,iDAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EAGA,gBAAA;EAKA,8BAAA;EACA,+BAAA;AAPZ;AAEY;EAnBJ;IAoBQ,gBAAA;EACd;AACF;AAIQ;EACQ,WAAA;EACA,yCAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,6HAAA;EAMA,kBAAA;AAPhB;AAUQ;EACI,gBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EAEA,aAAA;EACA,mBAAA;EACA,6BAAA;EAGA,cAAA;EACA,iBAAA;EACA,gBAAA;EAGA,kCAAA;EAEA,iBAAA;EAEA,iBAAA;EAEA,yDAAA;EAEA;+BAAA;EAGA,2BAAA;EACA,gCAAA;EAEA,wCAAA;AAnBZ;AAqBY;EACE,uBAAA;EAEA,qBAAA;AApBd;AAuBU;EACE,4BAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EAKA,UAAA;EACA,kBAAA;EACA,0BAAA;AAzBZ;AAmBY;EALF;IAMM,UAAA;IACA,WAAA;EAhBd;AACF;AAuBI;EACI,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,0BAAA;EACA,mHAAA;EAMA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;AA1BR;AA4BM;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,qEAAA;EACA,iBAAA;AA1BR;AA6BQ;EACE,2CAAA;AA3BV;AA8BI;EACI;IACE,4BAAA;IACA,UAAA;EA5BR;EA8BM;IACE,4BAAA;IACA,YAAA;EA5BR;EA8BM;IACE,4BAAA;IACA,UAAA;EA5BR;AACF;AA8BI;EAEI;IACE,YAAA;EA7BR;EA+BM;IACE,UAAA;EA7BR;EA+BM;IACE,YAAA;EA7BR;AACF;AA+BI;EACI;IACE,2BAAA;IACA,UAAA;EA7BR;EA+BM;IACE,4BAAA;IACA,UAAA;EA7BR;EA+BM;IACE,4BAAA;IACA,UAAA;EA7BR;AACF;;AAgCA;EACI,wIAAA;EAMA,4DAAA;AAlCJ;AAoCI;EACI,wIAAA;AAlCR;;AA0CA;EACI,sIAAA;EAMA,0DAAA;AA5CJ;AA8CI;EACI,sIAAA;AA5CR;;AAoDA;EACI,wIAAA;EAMA,4DAAA;AAtDJ;AAwDI;EACI,wIAAA;AAtDR","sourcesContent":["\n@import '../../scss/colors.scss';\n@import '../../scss/fonts.scss';\n\n.combineMain {\n    background-color: #07405E;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    height: 100dvh;\n    background-image: linear-gradient(180deg, rgba(0, 84, 130, 0.87), rgba(0, 47, 72, 1)),url('../../assets/img/wave-pattern.png');\n    background-repeat:repeat-x;\n    .instructionCircle{\n        color: $color-Secondary;\n        font-weight: 600;\n        line-height: 140%;\n        text-align: center;\n        width: 80%;\n        font-size: 22px;\n        font-family: $Roboto;\n        margin-top: -30dvh;\n        position: absolute;\n        margin-top: 20dvh;\n        @media (max-width: 350px){\n            margin-top: 12dvh;\n\n        }\n    }\n    .combineContainer{\n        @media (min-width: 450px){\n            width: 400px;\n        }\n        @media only screen and (max-height: 712px) {\n            height: 100%;\n        }\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        justify-content: center;\n        width: 100%;\n        height: 100dvh;\n        padding: 10px 0px;\n\n        .circle {\n            display: grid;\n            grid-template-areas: \"layer\";\n            place-items: center;\n            background: radial-gradient(\n            circle at center,\n            rgba(131, 219, 253, 1) 0%,\n            rgba(65, 223, 255, 0.8) 50%,\n            rgba(65, 223, 255, 0) 100%\n        );\n            outline: 0px;\n            backdrop-filter: blur(20px);\n            box-shadow: rgb(132, 220, 255) 0px 0px 440px 10px;\n            border-radius: 50%;\n            position: relative;\n            z-index: 2;\n            // max-width: 19vmin;\n            // max-height: 19vmin;\n            --radius: 19vmin;\n            @media (max-width: 500px){\n                --radius: 30vmin;\n\n            }\n            width: calc(2 * var(--radius));\n            height: calc(2 * var(--radius));\n        }\n        .circle::before{\n                content: \"\";\n                animation: pulseShadow 2s linear infinite;\n                z-index: -1;\n                position: absolute;\n                inset: -1px;\n                border-radius: 50%;\n                background: radial-gradient(\n                    circle at center,\n                    rgba(131, 219, 253, 1) 0%,\n                    rgba(65, 223, 255, 0.9) 50%,\n                    rgba(65, 223, 255, 0) 100%\n                );\n                filter: blur(40px); \n        }\n        \n        .stat {\n            grid-area: layer;\n            width: 10vmin;\n            height: 10vmin;\n            border-radius: 50%;\n          \n            display: grid;\n            place-items: center;\n            background-position: 'center';\n\n            // background: #ffc947;\n            color: #185adb;\n            font-weight: bold;\n            font-size: 3vmin;\n          \n            // Decimal value, 0-1 based on the child's index.\n            --d: calc(var(--i) / var(--total));\n            // Offset to get better starting placement on the circle\n            --r-offset: 1turn;\n            // Full circle\n            --r-amount: 1turn;\n            // Rotation based on the decimal and r modifiers\n            --r: calc((var(--r-amount) * var(--d)) + var(--r-offset));\n            // Rotate, transform out, then negative rotation so the content appears upright\n            --transform: rotate(var(--r)) translate(var(--radius))\n              rotate(calc(-1 * var(--r)));\n          \n            transform: var(--transform);\n            transition: transform 1s ease-in;\n\n            transition-delay: calc(0.1s / var(--i + 1));\n          \n            .circle {\n              --radius: calc(-20vmin);\n              // Animate the rotation\n              --r-offset: -1.75turn; //0.75turn;\n            }\n          }\n          .diamond{\n            background-repeat: no-repeat;\n            background-position: center;\n            width: 40%;\n            height: 40%;\n            @media screen and (max-width: 450px) {\n                width: 55%;\n                height: 55%;\n            }\n            z-index: 2;\n            position: relative;\n            background-size: 100% 100%;\n\n        }\n    }\n    .diamondsReaction{\n        animation-name: combine-diamonds ;\n        min-height: 20px;\n        min-width: 20px;\n        height: 20px;\n        width: 20px;\n        border-radius: 50%;\n        background: rgb(255,0,0);\n        background: radial-gradient(\n            circle at center,\n            rgba(131, 219, 253, 1) 0%,\n            rgba(65, 223, 255, 1) 50%,\n            rgba(65, 223, 255, 1) 100%\n        );\n        position: absolute;\n        z-index: 3;\n        left: 47%;\n        right: 40%;\n        bottom: 47%;\n        animation-duration: 1.5s;\n      }\n      .diamondsReaction::before {\n        content: \"\";\n        position: absolute;\n        inset: -1px;\n        background: linear-gradient(90deg,#5f8e8b 0%, rgb(97, 184, 255) 35%);\n        filter: blur(8px); \n      }\n    &.clicked {\n        .stat {\n          transform: rotate(0) translate(0) rotate(0);\n        }\n    }\n    @keyframes combine-diamonds {\n        0% {\n          -webkit-transform: scale(10)  ;\n          opacity: 1;\n        }\n        60% {\n          -webkit-transform: scale(20) ;\n          opacity: 0.5;\n        }\n        100% {\n          -webkit-transform: scale(30) ;\n          opacity: 0;\n        }\n    }\n    @keyframes pulseShadow {\n\n        0% {\n          opacity: 0.3;\n        }\n        50% {\n          opacity: 1;\n        }\n        100% {\n          opacity: 0.3;\n        }\n    }\n    @keyframes chestBlink {\n        0% {\n          -webkit-transform: scale(3)  ;\n          opacity: 1;\n        }\n        70% {\n          -webkit-transform: scale(10) ;\n          opacity: 1;\n        }\n        100% {\n          -webkit-transform: scale(20) ;\n          opacity: 0;\n        }\n    }\n}\n.green-gradient {\n    background: radial-gradient(\n        circle at center,\n        rgb(56, 183, 56,1) 0%,\n        rgba(111, 201, 111, 0.8) 50%,\n        rgb(167, 255, 167,0) 100%\n    ) !important;\n    box-shadow: rgb(111, 201, 111) 0px 0px 440px 10px !important; \n\n    &::before{\n        background: radial-gradient(\n            circle at center,\n            rgb(56, 183, 56,1) 0%,\n            rgba(111, 201, 111, 0.8) 50%,\n            rgb(167, 255, 167,0) 100%\n        ) !important;\n    }\n}\n.red-gradient {\n    background: radial-gradient(\n        circle at center,\n        rgba(183, 56, 56, 1) 0%,\n        rgba(162, 94, 94, 0.8) 50%,\n        rgba(255, 167, 167, 0) 100%\n    ) !important;\n    box-shadow: rgb(163, 91, 91) 0px 0px 440px 10px !important; \n\n    &::before{\n        background: radial-gradient(\n            circle at center,\n            rgba(183, 56, 56, 1) 0%,\n            rgba(179, 92, 92, 0.8) 50%,\n            rgba(255, 167, 167, 0) 100%\n        ) !important;\n    }\n}\n.blue-gradient {\n    background: radial-gradient(\n        circle at center,\n        rgba(56, 56, 183, 1) 0%,\n        rgba(111, 111, 201, 0.8) 50%,\n        rgba(167, 167, 255, 0) 100%\n    ) !important;\n    box-shadow: rgba(111, 111, 201, 1) 0px 0px 440px 10px !important;\n\n    &::before {\n        background: radial-gradient(\n            circle at center,\n            rgba(56, 56, 183, 1) 0%,\n            rgba(111, 111, 201, 0.8) 50%,\n            rgba(167, 167, 255, 0) 100%\n        ) !important;\n    }\n}\n","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n","@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap');\n$Bitter: 'Bitter', serif;   \n$Crimson-Pro: 'Crimson Pro', serif;\n$Alfa-Slab-One: 'Alfa Slab One', serif;\n$Noto-Serif: 'Noto Serif', serif;\n$Roboto: 'Roboto', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
